import { GuestForm } from './GuestForm';

type GuestFormProps = {
  isGenderSpecific: 'M' | 'F' | boolean;
  numberOfGuests: number;
  isDisabled: boolean;
  withGenderSelect: boolean;
  roomNumber?: number;
};

export function GuestDetails({
  isGenderSpecific,
  numberOfGuests,
  isDisabled,
  withGenderSelect,
  roomNumber = 0,
  ...rest
}: GuestFormProps) {
  return (
    <form {...rest}>
      <fieldset disabled={isDisabled}>
        <GuestForm
          withLeadGuest={true}
          isGenderSpecific={isGenderSpecific}
          withGenderSelect={withGenderSelect}
          numberOfGuests={numberOfGuests}
          roomNumber={roomNumber}
        />
      </fieldset>
    </form>
  );
}
